import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { HiPlus, HiOutlineClipboardList, HiOutlineTruck } from "react-icons/hi";
import Search from "../StockManagement/sub-components/Search";
import TableActions from "../StockManagement/sub-components/TableActions";
import { LogService } from "../../../services/LogService";
import moment from "moment";
const AllTreeFells = () => {
  const navigate = useNavigate();
  const treeFellColumns = [
    {
      name: "Tree Fell Code",
      selector: (row) => row.treeFellCode,
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    // {
    //   name: "Status",
    //   selector: (row) => row.status,
    // },
    {
      name: "Total Quantity",
      selector: (row) => row.totalQuantity,
    },
    {
      name: "Date",
      selector: (row) => moment(row.dateCreated).format('yyyy-MM-DD'),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div>
          <TableActions
            viewAction={() => navigate(`/dashboard/tree-fell/${row.treeFellId}`)}
            noDelete
          />
        </div>
      ),
    },
  ];

  const [treefell,setTreefell] = useState([])
  useEffect(() => {
    handletreefell();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [pending, setPending] = useState(true);
  const handletreefell = () => {
    LogService.GetAllTreeLogs().then((res) => {
      
      setTreefell(...treefell, res);
      setPending(false);
      // console.log(concessions)
      
    });
  };
  const [search] = useState("");

  useEffect(() => {
    console.log(search)
  }, [search]);
  return (
    <div className="w-full">
      <div className="flex flex-col gap-2 mb-3 md:mb-0 md:flex-row md:items-center md:justify-between">
        <Search placeholder="Search TreeFells" />
        <div className="grid grid-cols-2 gap-2 md:flex md:items-center">
          <Link
            to="/dashboard/tree-fell/defects"
            className="inline-flex items-center justify-center gap-2 px-4 text-sm font-semibold transition bg-white border shadow-sm whitespace-nowrap h-10 rounded-xl border-slate-200 text-slate-700 hover:border-tclPrimary/40 hover:text-tclPrimary hover:shadow-md"
          >
            <HiOutlineClipboardList className="w-4 h-4" />
            Defects
          </Link>
          <Link
            to="/dashboard/tree-fell/tracking"
            className="inline-flex items-center justify-center gap-2 px-4 text-sm font-semibold transition bg-white border shadow-sm whitespace-nowrap h-10 rounded-xl border-slate-200 text-slate-700 hover:border-tclPrimary/40 hover:text-tclPrimary hover:shadow-md"
          >
            <HiOutlineTruck className="w-4 h-4" />
            Log Tracking
          </Link>
          <Link
            to="/dashboard/tree-fell/add"
            className="inline-flex items-center justify-center col-span-2 gap-2 px-4 text-sm font-semibold text-white transition shadow-sm whitespace-nowrap h-10 rounded-xl bg-tclPrimary shadow-tclPrimary/30 hover:bg-tclPrimary/90 hover:shadow-md"
          >
            <HiPlus className="w-4 h-4" />
            New Fell
          </Link>
        </div>
      </div>
      <DataTable
        className="w-full rounded rounded-lg"
        columns={treeFellColumns}
        data={treefell.filter((item) => {
          if (search === "") {
            return item;
          } else{
           return item.description.toLowerCase().includes(search.toLowerCase())||
           item.treeFellCode.toLowerCase().includes(search.toLowerCase())
           
          }
        })}
        progressPending={pending}
        pagination
      />
    </div>
  );
};

export default AllTreeFells;
